import {DesktopDevice} from '@mintdata-wsp/common/state/ui/visualDesigner/surface/component/viewport/viewportLayout/DesktopDevice';
import {DeviceOrientation} from '@mintdata-wsp/common/state/ui/visualDesigner/surface/component/viewport/viewportLayout/DeviceOrientation';
import {DeviceType} from '@mintdata-wsp/common/state/ui/visualDesigner/surface/component/viewport/viewportLayout/DeviceType';
import {MobileDevice} from '@mintdata-wsp/common/state/ui/visualDesigner/surface/component/viewport/viewportLayout/MobileDevice';
import {TabletDevice} from '@mintdata-wsp/common/state/ui/visualDesigner/surface/component/viewport/viewportLayout/TabletDevice';
import {Property} from '@mintdata/mint-kit/api/decorators/Property';
import {PositiveUnits} from '@mintdata/mint-kit/api/models/PositiveUnits';
import {AStringEnumConfig} from '@mintdata/mint-kit/impl/properties/typeConfigs/AEnumConfig';
import {PositiveUnitsConfig} from '@mintdata/mint-kit/impl/properties/typeConfigs/PositiveUnitsConfig';

export class ViewportLayoutModel
{
    @Property<DeviceType>({
        title: 'Device type',
        tip: 'Device type',
        isRequired: true,
        typeConfig: AStringEnumConfig,
        typeCtor: DeviceType
    })
    deviceType:DeviceType;

    @Property<DesktopDevice>({
        title: 'Desktop Device',
        tip: 'Desktop Device',
        isRequired: true,
        typeConfig: AStringEnumConfig,
        typeCtor: DesktopDevice
    })
    desktopDevice:DesktopDevice;

    @Property<TabletDevice>({
        title: 'Tablet Device',
        tip: 'Tablet Device',
        isRequired: true,
        typeConfig: AStringEnumConfig,
        typeCtor: TabletDevice
    })
    tabletDevice:TabletDevice;

    @Property<MobileDevice>({
        title: 'Mobile Device',
        tip: 'Mobile Device',
        isRequired: true,
        typeConfig: AStringEnumConfig,
        typeCtor: MobileDevice
    })
    mobileDevice:MobileDevice;

    @Property<PositiveUnits>({
        title: 'Custom Width',
        tip: 'Custom Width',
        isRequired: true,
        typeConfig: PositiveUnitsConfig,
        typeCtor: PositiveUnits
    })
    customWidth:PositiveUnits;

    @Property<PositiveUnits>({
        title: 'Custom Height',
        tip: 'Custom Height',
        isRequired: true,
        typeConfig: PositiveUnitsConfig,
        typeCtor: PositiveUnits
    })
    customHeight:PositiveUnits;

    @Property<DeviceOrientation>({
        title: 'Desktop orientation',
        tip: 'Desktop orientation',
        isRequired: true,
        typeConfig: AStringEnumConfig,
        typeCtor: DeviceOrientation
    })
    desktopOrientation:DeviceOrientation;

    @Property<DeviceOrientation>({
        title: 'Tablet orientation',
        tip: 'Tablet orientation',
        isRequired: true,
        typeConfig: AStringEnumConfig,
        typeCtor: DeviceOrientation
    })
    tabletOrientation:DeviceOrientation;

    @Property<DeviceOrientation>({
        title: 'Mobile orientation',
        tip: 'Mobile orientation',
        isRequired: true,
        typeConfig: AStringEnumConfig,
        typeCtor: DeviceOrientation
    })
    mobileOrientation:DeviceOrientation;

    @Property<DeviceOrientation>({
        title: 'Custom size orientation',
        tip: 'Custom size orientation',
        isRequired: true,
        typeConfig: AStringEnumConfig,
        typeCtor: DeviceOrientation
    })
    customSizeOrientation:DeviceOrientation;

    public constructor(deviceType?:DeviceType,
                       desktopDevice?:DesktopDevice,
                       tabletDevice?:TabletDevice,
                       mobileDevice?:MobileDevice,
                       customWidth?:PositiveUnits,
                       customHeight?:PositiveUnits,
                       desktopOrientation?:DeviceOrientation,
                       tabletOrientation?:DeviceOrientation,
                       mobileOrientation?:DeviceOrientation,
                       customSizeOrientation?:DeviceOrientation)
    {
        this.deviceType = deviceType;
        this.desktopDevice = desktopDevice;
        this.tabletDevice = tabletDevice;
        this.mobileDevice = mobileDevice;
        this.customWidth = customWidth;
        this.customHeight = customHeight;
        this.desktopOrientation = desktopOrientation;
        this.tabletOrientation = tabletOrientation;
        this.mobileOrientation = mobileOrientation;
        this.customSizeOrientation = customSizeOrientation;
    }

    public static default():ViewportLayoutModel
    {
        return new ViewportLayoutModel(
            DeviceType.desktop(),
            DesktopDevice.desktop(),
            TabletDevice.tablet(),
            MobileDevice.mobile(),
            PositiveUnits.fromPixels(768),
            PositiveUnits.fromPixels(1024),
            DeviceOrientation.horizontal(),
            DeviceOrientation.horizontal(),
            DeviceOrientation.vertical(),
            DeviceOrientation.horizontal()
        );
    }
}
